"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabButtons;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _TabButtonsModule = _interopRequireDefault(require("./TabButtons.module.scss"));

var _Button = _interopRequireDefault(require("../../../../../inputElements/Button/Button"));

var _TabButtons = _interopRequireDefault(require("./TabButtons.i18n"));

var _EButtonType = _interopRequireDefault(require("../../../../../inputElements/Button/EButtonType"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function TabButtons(_ref) {
  var _ref$currentTab = _ref.currentTab,
      currentTab = _ref$currentTab === void 0 ? "CLASS" : _ref$currentTab,
      onChangeTab = _ref.onChangeTab,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var handleChangeTab = (0, _react.useCallback)(function (tab) {
    if (currentTab !== tab) {
      if (onChangeTab) onChangeTab(tab);
    }
  }, [currentTab, onChangeTab]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_TabButtonsModule.default.tabButtons, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.CMD_TAB_58X19,
    className: (0, _classnames.default)(_TabButtonsModule.default.tabBtn, _TabButtonsModule.default.class),
    isDisabled: currentTab === "CLASS",
    onClick: function onClick() {
      return handleChangeTab("CLASS");
    }
  }, formatMessage(_TabButtons.default.class)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.CMD_TAB_58X19,
    className: (0, _classnames.default)(_TabButtonsModule.default.tabBtn, _TabButtonsModule.default.combos),
    isDisabled: currentTab === "COMBOS",
    onClick: function onClick() {
      return handleChangeTab("COMBOS");
    }
  }, formatMessage(_TabButtons.default.combos)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.CMD_TAB_58X19,
    className: (0, _classnames.default)(_TabButtonsModule.default.tabBtn, _TabButtonsModule.default.crafting),
    isDisabled: currentTab === "CRAFTING",
    onClick: function onClick() {
      return handleChangeTab("CRAFTING");
    }
  }, formatMessage(_TabButtons.default.crafting)));
}